module.exports = __webpack_public_path__ + "img/EcoCard.3a269d2c.svg";